import * as T from "./bindings/Translation2";
import { make as Tooltip } from "./components/Tooltip.bs.js";
import { Desc } from "./components/RitoDescription2";

type Anomaly = {
  id: string;
  title: string;
  type: string;
  desc: string;
};

const joinAnomalySplit = (baseParts: Array<String>): Array<String> => {
  if (baseParts.length < 2) {
    return baseParts;
  }
  let parts = baseParts.slice(0);
  let minLen = 999;
  let minLenIdx = 999;
  for (let idx = 0; idx < parts.length - 1; idx++) {
    const joinLen = parts[idx].length + parts[idx + 1].length + 1;
    if (joinLen < minLen) {
      minLen = joinLen;
      minLenIdx = idx;
    }
  }
  if (minLen < 9) {
    parts.splice(minLenIdx, 2, parts[minLenIdx] + " " + parts[minLenIdx + 1]);
    return joinAnomalySplit(parts);
  } else {
    return parts;
  }
};

const splitAnomalyTitle = (title: string): Array<String> => {
  const split = title.split(" ");

  return joinAnomalySplit(split);
};

export default function AnomalyItem({
  id,
  className,
}: {
  id: string;
  className?: string;
}) {
  const title = T.common(id);
  let parts = splitAnomalyTitle(title);
  let maxLen = Math.max(...parts.map((v) => v.length));
  return (
    <Tooltip
      title={
        <>
          <div className="flex justify-between items-center gap-2">
            <div className="font-montserrat font-medium pb-2">
              {T.common(id)}
            </div>
          </div>
          <div>
            <div className="text-sm leading-none font-montserrat font-medium text-white2 pb-2">
              {T.common(id + "_typ")}
            </div>
          </div>
          <Desc
            className="text-sm leading-tight"
            desc={T.common(id + "_desc")}
          />
        </>
      }
    >
      <div
        className={
          className +
          " anomaly-img flex flex-col justify-center text-center bg-bg2 rounded h-[68px] p-[3px] leading-tight " +
          (parts.length < 3 && maxLen < 8 ? "text-[16px] " : "text-[14px] ")
        }
      >
        {parts.map((part) => (
          <div>{part}</div>
        ))}
      </div>
    </Tooltip>
  );
}
